// removed by extract-text-webpack-plugin
module.exports = {"popoverZIndex":"19","popoverOZIndex":"21","root":"Checkbox__root___ySCt4","pseudoCheckbox":"Checkbox__pseudoCheckbox___iG8Sx"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Checkbox/Checkbox.scss
 ** module id = 1238
 ** module chunks = 0
 **/